module.exports = __webpack_public_path__ + "img/meika.75d898da.png";